/**
 * @file InstallmentSelection.jsx
 * @description Component to manage installments with duplicate handling.
 */
import { MenuItem, Skeleton, TextField, Box, Typography, Button } from "@mui/material";
import React, { useState, useEffect } from "react";

export const LifecycleSelection = ({
  isLoading,
  lifecycleEvents,
  handleLifecycleChange,
  selectedEvent,
  handleLifecycleSave
}) => {

  const findFirstNullIndex = (events) => {
    for (let i = 0; i < events.length; i++) {
      if (events[i].installmentnumber === null) {
        return i; // Return the index of the first null installmentnumber
      }
    }
    return events.length; // If no null is found, return full length
  };

  return (

    <Box px={2} overflow="scroll">
      <div className="inst-scroll-wrapper">
        {isLoading ? (
          <Skeleton variant="rounded" sx={{ mt: 1 }} width={180} height={36} />
        ) : (
          <span className="installment-head">
            Add lifecycle event
          </span>
        )}
        <div className="inst-scroll-wrapper" style={{ display: "flex" }}>
          {isLoading ? (
            <Skeleton variant="rounded" sx={{ mt: 1 }} width={380} height={44} />
          ) : (
            <TextField
              sx={{
                "& .MuiInputBase-input": {
                  m: 0,
                  p: "4px 8px",
                  width: "100%"
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  height: 44,
                },
                my: 1,
                width: "45%",
              }}
              select
              variant="outlined"
              value={selectedEvent || ""}
              onChange={(e) => handleLifecycleChange(e.target.value)}
              placeholder="Choose event"
            >
              {/* slice(0, findFirstNullIndex(lifecycleEvents)) */}
              {lifecycleEvents.map((option,idx) => (
                <MenuItem key={idx} value={option.id}>
                  {option.eventname}
                </MenuItem>
              ))}
            </TextField>
          )}
          {isLoading ? (
            <Skeleton variant="rounded" sx={{ mt: 1 }} width={100} height={44} style={{ marginLeft: "12px" }} />
          ) : (
            <Button
              variant="contained"
              className="ly-submit-btn"
              onClick={handleLifecycleSave}>
              Submit
            </Button>
          )}
        </div>
      </div>
    </Box>

  );
};
